import { computed } from "vue";

interface Payment {
  name: string;
  amount: number;
  type: string;
}

interface Receipt {
  payment: Payment[];
}

interface PaymentSummary {
  name: string;
  qty: number;
  amount: number;
}

export const usePaymentSummary = (receipts:any) => {
  const summary = computed(() => {
    const paymentSummary: Record<string, PaymentSummary> = {};
    let filteredReceipts = receipts.filter((receipt:any) => !receipt.IsDeleted);
    
    filteredReceipts.forEach((receipt:any) => {
      if(typeof receipt.PaymentType == "string"){
        paymentSummary[receipt.PaymentType] = {
          name: receipt.PaymentType,
          qty: 1,
          amount: receipt.GrandTotal || 0
        };
      }else{
        receipt.payment.forEach((p:any) => {
          if (paymentSummary[p.Name]) {
            paymentSummary[p.Name].quantity++;
            paymentSummary[p.Name].amount += receipt.GrandTotal || 0 ;
          } else {
            paymentSummary[p.Name] = {
              name: p.Name,
              qty: 1,
              amount:  receipt.GrandTotal || 0 //  p.amount,
            };
          }
        });
      }
      
    });

    return Object.values(paymentSummary).sort((a, b) => b.amount - a.amount);
  });

  return {
    summary,
  };
};
